<app-basic-grid 
  [configuration]="pursuitsGridConfiguration"
  [data]="pursuitsGridData">
</app-basic-grid>